module.exports = __webpack_public_path__ + "img/picto-maison.61ef6a4f.svg";